// NOTE: Bu metin bir taslaktır. Hukuki kontrol önerilir.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function KvkkNotice() {
  return (
    <LegalPage
      title="KVKK Aydınlatma Metni"
      subtitle="6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında veri sahibi olarak haklarınızı ve veri işleme süreçlerimizi açıklıyoruz."
      lastUpdated="Mayıs 2026"
      version={LEGAL_VERSIONS.kvkk}
      testid="kvkk-page"
    >
      <h2>1. Veri Sorumlusu</h2>
      <p>
        İşbu Aydınlatma Metni kapsamında veri sorumlusu, <strong>uSeen</strong>
        (useen.ai) olarak ifade edilen platformdur. Şirket bilgileri ve KEP adresi
        kurumsallaşma süreçleri tamamlandığında bu metinde güncellenecektir.
      </p>

      <h2>2. İşlenen Kişisel Veri Kategorileri</h2>
      <ul>
        <li><strong>Kimlik:</strong> Ad-soyad</li>
        <li><strong>İletişim:</strong> E-posta adresi</li>
        <li><strong>Müşteri işlem:</strong> Hesap kaydı, paket bilgisi, kullanım limitleri</li>
        <li><strong>İşlem güvenliği:</strong> Şifre özetleri, oturum bilgileri, IP ve cihaz bilgileri</li>
        <li><strong>Pazarlama:</strong> Verdiğiniz pazarlama izni ve tercihler</li>
        <li><strong>Diğer:</strong> Eklediğiniz işletme ve web sitesi adresi gibi platforma kendiniz sağladığınız veriler</li>
      </ul>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Üyelik oluşturulması ve hizmetin sağlanması</li>
        <li>AI görünürlük analizinin ve önerilerinin üretilmesi</li>
        <li>Plan/limit yönetimi ve müşteri destek süreçleri</li>
        <li>Bilgi güvenliği, sahteciliğin önlenmesi ve kötüye kullanım tespiti</li>
        <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
        <li>Açık rıza vermeniz hâlinde ürün ve kampanya iletişimi</li>
      </ul>

      <h2>4. Hukuki Sebepler</h2>
      <p>Kişisel verileriniz, KVKK madde 5/2 uyarınca aşağıdaki hukuki sebeplere dayanılarak işlenir:</p>
      <ul>
        <li>Sözleşmenin kurulması ve ifası (Kullanım Koşulları kapsamında)</li>
        <li>Veri sorumlusunun meşru menfaati</li>
        <li>Hukuki yükümlülük</li>
        <li>Açık rıza (pazarlama izni gibi opsiyonel veriler için)</li>
      </ul>

      <h2>5. Kişisel Verilerin Aktarımı</h2>
      <p>
        Verileriniz; barındırma sağlayıcıları, AI model sağlayıcıları (OpenAI, Anthropic
        vb.) ve ileride entegre edilecek ödeme/iletişim hizmet sağlayıcıları ile yalnızca
        hizmetin sağlanması için gerekli ölçüde paylaşılabilir. Yurt dışına aktarım söz
        konusu olduğunda KVKK madde 9 kapsamındaki güvence yöntemleri uygulanır.
      </p>

      <h2>6. Saklama Süresi</h2>
      <p>
        Kişisel verileriniz hizmetin sağlanması için gerekli olduğu süre boyunca veya
        mevzuatın öngördüğü zaman aşımı süreleri sonuna kadar saklanır; ardından silinir
        veya anonim hâle getirilir.
      </p>

      <h2>7. İlgili Kişi Hakları</h2>
      <p>KVKK madde 11 kapsamında veri sahibi olarak şu haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>İşleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
        <li>KVKK madde 7'deki şartlar çerçevesinde verilerin silinmesini isteme</li>
        <li>Düzeltme/silme işlemlerinin üçüncü kişilere bildirilmesini isteme</li>
        <li>Otomatik sistemler ile analiz edilmesi sonucu aleyhinize çıkan sonuçlara itiraz etme</li>
        <li>Kanuna aykırı işleme nedeniyle uğradığınız zararın giderilmesini talep etme</li>
      </ul>

      <h2>8. Başvuru Yöntemi</h2>
      <p>
        Yukarıdaki haklarınıza ilişkin taleplerinizi <a href="/iletisim">iletişim sayfası</a>
        üzerinden bize iletebilirsiniz. Talebiniz en geç 30 gün içinde sonuçlandırılır.
      </p>
    </LegalPage>
  );
}
